import En0 from "../../../../content/blog/ah_gi/en.md";
import Tc0 from "../../../../content/blog/ah_gi/tc.md";
import Jp0 from "../../../../content/blog/ah_gi/jp.md";
import * as React from 'react';
export default {
  En0,
  Tc0,
  Jp0,
  React
};